import { Component } from '@angular/core';
import { BankBaseTabPageComponent } from '../bank-base-tab-page.component';

@Component({
  selector: 'bank-sites',
  standalone: true,
  imports: [],
  templateUrl: './bank-sites.component.html',
  styleUrl: './bank-sites.component.less'
})
export class BankSitesComponent extends BankBaseTabPageComponent {
}
